<template>
    <div v-if="eventItem">
        <v-toolbar v-if="!hideTopBar" tile dark class="secondary">
            <slot name="beforeTitle"></slot>
            <v-toolbar-title>Ιστορικό {{texts[eventItem.EventType_ID]}}ς</v-toolbar-title>
        </v-toolbar>
        <v-row class="ma-2">
          <v-col lg="12" md="12" sm="12">
            <v-card flat>
              <v-card-title> Στοιχεία γεγονότος</v-card-title>
              <v-card-text> {{ eventItem.Description}}</v-card-text>
              <v-row >
                <v-col>
                  <v-list-item :to="'/building/'+eventItem.Branch_ID">
                    <v-list-item-icon>
                      <v-icon>mdi-domain</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title> {{eventItem.BranchAddress}}, {{eventItem.BranchAreaName}}
                      </v-list-item-title>
                      <v-list-item-subtitle>Κτήριο</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col>
                  <v-list-item :to="'/lift/'+eventItem.Project_ID">
                    <v-list-item-icon>
                      <v-icon> mdi-elevator </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title> {{eventItem.ProjectName}}</v-list-item-title>
                      <v-list-item-subtitle><wnl-text>Ανυψωτικό</wnl-text></v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
            </v-card>

            <v-card class="mt-lg-6 mt-sm-1" flat v-if="userDetails.Allows.ShowDiagnosiAction && eventItem.Diagnosi">
              <v-card-title> Σημειώσεις γραφείου</v-card-title>
              <v-card-text>
                {{eventItem.Diagnosi}}
              </v-card-text>
            </v-card>
            <v-card class="mt-lg-6 mt-sm-1" flat v-if="userDetails.Allows.ShowDiagnosiAction && eventItem.Diagnosi">
              <v-card-title> Ενεργείες που έγιναν</v-card-title>
              <v-card-text>
                {{eventItem.Actions}}
              </v-card-text>
            </v-card>
            <v-card flat class="mt-lg-6 mt-sm-1"
                    v-if="(userDetails.Allows.ShowSintirName && eventItem.TexnitisName) ||  (userDetails.Allows.ShowSintirPhone  &&  eventItem.TexnitisMobileNumber )">
              <v-card-title>
                Τεχνικός
              </v-card-title>
              <v-list>
                <v-list-item v-if="userDetails.Allows.ShowSintirName && eventItem.TexnitisName">
                  <v-list-item-action>
                    <v-icon>mdi-account</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title> {{eventItem.TexnitisName}}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="userDetails.Allows.ShowSintirPhone && eventItem.TexnitisMobileNumber">
                  <v-list-item-action>
                    <v-icon>mdi-phone</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title> {{eventItem.TexnitisMobileNumber}}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-col>
          <v-col lg="12" md="12" sm="12">
                <v-card class="fill-height" :color="isMobile?'transparent':'white'" flat>
                  <v-card-title> Ιστορικό </v-card-title>
                  <v-timeline dense clipped align-top class="pr-4 ">
                        <v-timeline-item
                                v-if="eventItem.DateEnd"
                                color="primary"
                                small
                        >
                            <v-card>
                                <v-list-item>
                                    <v-list-item-action>
                                        {{eventItem.DateEnd | date }}
                                        <v-list-item-action-text v-if="userDetails.Allows.ShowStartEnd">
                                            {{eventItem.DateEnd |time }}
                                        </v-list-item-action-text>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <strong>Τέλος εργασίων για την {{texts[eventItem.EventType_ID]}} </strong>
                                    </v-list-item-content>

                                </v-list-item>
                            </v-card>
                        </v-timeline-item>
                        <v-timeline-item
                                v-if="eventItem.DateStart"
                                color="green"
                                small
                        >
                            <v-card>
                                <v-list-item>
                                    <v-list-item-action>
                                        {{eventItem.DateStart | date}}
                                        <v-list-item-action-text v-if="userDetails.Allows.ShowStartEnd">
                                            {{eventItem.DateStart | time}}
                                        </v-list-item-action-text>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <strong>Έναρξη εργασιών για την {{texts[eventItem.EventType_ID]}} </strong>
                                        <div class="caption">
                                            O τεχνικός βρίσκεται στον χώρο σας και έχει ξεκινήσει τις
                                            απαραίτητες εργασίες
                                            απαραίτητες εργασίες
                                        </div>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-card>

                        </v-timeline-item>
                        <v-timeline-item
                                v-if="eventItem.DateReaded"
                                color="secondary"
                                small
                        >
                            <v-card>
                                <v-list-item>
                                    <v-list-item-action>
                                        {{eventItem.DateReaded | date }}
                                        <v-list-item-action-text>
                                            {{eventItem.DateReaded |time}}
                                        </v-list-item-action-text>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <strong>Ο τεχνικός ενημερώθηκε </strong>
                                        <div class="caption">Ο τεχνικός έλαβε την {{texts[eventItem.EventType_ID]}} στο
                                            κινήτο του.
                                        </div>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-card>
                        </v-timeline-item>
                        <v-timeline-item
                                v-if="eventItem.DateEventInsert"
                                color="secondary lighten-3"
                                small
                        >
                            <v-card>
                                <v-list-item>
                                    <v-list-item-action>
                                        {{eventItem.DateEventInsert | date }}
                                        <v-list-item-action-text>
                                            {{eventItem.DateEventInsert |
                                            time }}
                                        </v-list-item-action-text>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <strong>Καταχώρηση γεγονότος</strong>
                                        <div class="caption">Η {{texts[eventItem.EventType_ID]}} καταχωρήθηκε στο
                                            σύστημα
                                        </div>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-card>
                        </v-timeline-item>
                    </v-timeline>
                </v-card>
            </v-col>

        </v-row>
    </div>
</template>

<script>
    import {mapState, mapActions, mapGetters,} from 'vuex'
    import WnlText from "@/wl-unit-text/WnlText";

    export default {
        name: "EventCard",
      components: {WnlText},
      props: {
            eventId: Number,
            hideTopBar: Boolean,
        },
        data: () => ({
            eventItem: null,
            texts: {
                1: 'Συντήρηση',
                2: 'Βλάβη',
                3: 'Εργασία'
            }
        }),

        created() {
            this.getSingleEvent(this.eventId).then(
                resp => this.eventItem = resp
            )
        },
        methods: {
            ...mapActions([
                "getSingleEvent"
            ])
        },
        computed: {
            ...mapGetters([
                "isMobile",
                "userDetails"
            ]),

        },
    }
</script>

<style scoped>

</style>
